import ViewWrapper from './ViewWrapper'

export default ViewWrapper
